<template>
  <div class="q-box">
    <div class="container ">
      url tdcID: {{$route.query.tdcid}}
      <div class="surveys mb-2" v-for="(s, sCount) in survey">
        <router-link :to="'/survey/'+sCount" class="btn btn-dark">
          {{s.name}}
        </router-link>
      </div>
      <button type="button" name="button" @click="testApiPost()">Send data test</button>

    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import {mapActions} from 'vuex';
import Axios from 'axios';
import qs from 'qs';

export default {
  name: 'fp',
  data () {
    return {
      msg: 'Overskrift',
    }
  },
  computed: {
    ...mapGetters([
      'survey',
      'surveyIsActive',
      'spinner'
    ])
  },
  methods: {
    ...mapActions([
      'setSurveyActive',
    ]),
    testApiPost(){
        var postData = {
          MarketingCampaignId: "1805802456",
          email: "lautester@link.com",
          mdbIdentifier: "DigitaltSikkerhedstjek",
          Datasource: "Brand",
          ProjectName: "Brand",
          personName:"Lau tester",
          company: "Think! Digital ApS",
          street:	"Rosenvængets Allé",
          streetnumber:	"1",
          floor:"25",
          zipCode:2100,
          city: "København Ø",
          kundetype: "Company",
          isCustomer: "NonCustomer",
          emailpermission1_Id: "yes",
          TDCId: "202816492",
          emailpermission1: "Kampagne permission, erhverv",
          phone_1: "31311313",
          phonepermission1_Text: "Kampagne permission, erhverv",
          phonepermission1: "yes",
          text_name1: "urlToSurvey",
          text_1: 'https://sikkerhedstjek.dk/rapport/test'
        }

        //db.ref('email').child(s).child(this.firm.firmId).set(postData);

        var bodyFormData = new FormData;
        for (var k in postData){
            if (postData.hasOwnProperty(k)) {
              bodyFormData.append(k, postData[k]);
              //bodyFormData.set(k, postData[k]);
            }
        }


        let axiosConfig = {
            responseType: 'json',
            headers: {'Content-Type': 'multipart/form-data'}
        };

        Axios.post('https://mdbprodssl.falck.com/marketingform/MarketingServicePost.ashx', bodyFormData, axiosConfig )
        .then((res) => {
          //this.$router.push({ path: '/rapport/'+s+'/'+this.firm.firmId+'' })
          console.log(res);
        })
        .catch((err) => {
          console.log("AXIOS ERROR: ", err);
        })
    }
  },
  mounted() {
    this.$router.push({ path: '/survey/0/' })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.container{
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/frontpage.vue